

export class WorkOrderChangeStatus {
    workOrderId: string;
    comments: string;
}
